import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TextAlign } from '@domgen/dgx-fe-common';
import { RichTextComponent } from '@domgen/dgx-fe-components/content';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { ErrorPageContentBlock } from '@error/util-models';

@Component({
  templateUrl: './error-page-content-block.component.html',
  styleUrls: ['./error-page-content-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgIf,
    RichTextComponent,
  ],
})
export class ErrorPageContentBlockComponent implements ErrorPageContentBlock {
  @Input() body?: string;
  @Input() subtitle?: string;
  @Input() textAlign: TextAlign = 'center';
  @Input() title?: string;
}
